export default "__VITE_ASSET__CcEB9PvZ__"